export const ENTITY_TYPES = ['Company', 'Trust', 'LLP', 'Partnership', 'HUF', 'Sole Proprietorship', 'AOP/BOI', 'Other'];

export const COMMON_DOCS = [
  { key: 'entity_pan', label: 'PAN Card of the Entity', required: true },
  { key: 'bank_statement', label: 'Entity Bank Statement (latest — with address, MICR & IFSC)', required: true },
  { key: 'financials', label: 'Last 3 Years Balance Sheet & P&L', required: true, hint: 'Combine into a single PDF if possible.' },
  { key: 'authorised_signatories_list', label: 'List of Authorised Signatories', required: true },
];

export const ENTITY_DOCS = {
  'Company': [
    { key: 'coi', label: 'Certificate of Incorporation', required: true },
    { key: 'moa', label: 'Memorandum of Association (MOA)', required: true },
    { key: 'aoa', label: 'Articles of Association (AOA)', required: true },
    { key: 'board_resolution', label: 'Board Resolution', required: true },
  ],
  'Trust': [{ key: 'trust_deed', label: 'Trust Deed', required: true }],
  'LLP': [
    { key: 'llp_agreement', label: 'LLP Agreement / Partnership Deed', required: true },
    { key: 'coi', label: 'Certificate of Incorporation', required: false },
  ],
  'Partnership': [{ key: 'partnership_deed', label: 'Partnership Deed', required: true }],
  'HUF': [
    { key: 'huf_deed', label: 'HUF Deed / Declaration', required: true },
    { key: 'coparceners_list', label: 'List of Coparceners', required: true },
  ],
  'Sole Proprietorship': [{ key: 'business_proof', label: 'Proof of Business / Registration (GST, Shop Act, etc.)', required: true }],
  'AOP/BOI': [{ key: 'constitution_doc', label: 'Constitution / Registration / Agreement Document', required: true }],
  'Other': [{ key: 'constitution_doc', label: 'Constitution / Registration Document', required: true }],
};

export const PERSON_LABEL = {
  'Company': 'Director',
  'Trust': 'Trustee',
  'LLP': 'Partner',
  'Partnership': 'Partner',
  'HUF': 'Karta / Coparcener',
  'Sole Proprietorship': 'Proprietor',
  'AOP/BOI': 'Member',
  'Other': 'Authorised Person',
};

export const getEntityDocs = (entityType) => [...COMMON_DOCS, ...(ENTITY_DOCS[entityType] || ENTITY_DOCS['Other'])];
